import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Splits raw input (typed or pasted) into clean keyword chips. Handles
 * commas, newlines, tabs, and surrounding whitespace. Used by both the
 * onboarding flow and the brief settings panel so paste-from-spreadsheet
 * just works.
 *
 * Example inputs that all parse identically:
 *   "cortisol, stress, sleep"
 *   "cortisol\nstress\nsleep"
 *   "cortisol,stress,sleep,"
 *   "cortisol , stress  ,  sleep"
 */
export function splitKeywordsInput(raw: string): string[] {
  return raw
    .split(/[,\n\t]+/)
    .map(s => s.trim())
    .filter(Boolean)
}

/**
 * Falls back to the legacy single product_image_url column for campaign
 * rows saved before the multi-image product_image_urls array existed.
 */
export function getCampaignImages(campaign: {
  product_image_urls?: string[] | null
  product_image_url?: string | null
}): string[] {
  if (campaign.product_image_urls?.length) return campaign.product_image_urls
  return campaign.product_image_url ? [campaign.product_image_url] : []
}
